import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { persistCompanyIdOnLogin } from "configs/authStorage";

interface User {
  _id: string;
  email: string;
  name: string;
  role: string;
  companyName?: string;
  companyID?: any;
  branchID?: any;
  [key: string]: any;
}

interface Subdomain {
  result?: {
    name?: string;
    logo?: string;
  };
}

interface AuthState {
  token: string | null;
  user: User | null;
  subdomain: Subdomain | null;
}

const initialState: AuthState = {
  token: null,
  user: null,
  subdomain: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setSubdomain: (state, action: PayloadAction<Subdomain>) => {
      state.subdomain = action.payload;
    },
    login: (state, action: PayloadAction<{ token: string; user: User; subdomain?: Subdomain }>) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.subdomain = action.payload.subdomain || null;
      localStorage.setItem("token", action.payload.token);
      persistCompanyIdOnLogin(action.payload.user);
    },
    logout: (state) => {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      state.token = null;
      state.user = null;
      state.subdomain = null;
    },
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
  },
});

export const { login, logout, setUser, setSubdomain } = authSlice.actions;
export default authSlice.reducer;

